import { Container } from "inversify";

import SERVICE_IDENTIFIER from "../../constants/identifiers";

import IApp from "../IApp";
import MadnesApp from "./MadnesApp";
import MadnesLoader from "./MadnesLoader";
import MadnesInfoPages from "./MadnesInfoPages";
import ILoader from "../../loader/Iloader";
import MadnesAudio from "./MadnesAudio";
import InitMadnesApp from "./InitMadnesApp";
import IInitApp from "../IInitApp";
import MadnesCommander from "../../commander/MadnesCommander";
import GameMadnesCore from "../../game/GameMadnesCore";
import * as madnes from "./madnes";
import AbstractInfoPages from "../AbstractInfoPages";
import IEngine from "../IEngine";
import MadnesEngine from "./MadnesEngine";
import IAudio from "../IAudio";
import EngineDebug from "../EngineDebug";
import MadnesDebug from "./MadnesDebug";
import { defineSlotGame } from "../../game/defineGame";
import SystemConfig from "../../system/SystemConfig";
import IframeInfopages from "../IframeInfoPages";
import AbstractIframePage from "../AbstractIfarmePage";
import IframeParagraphPage from "../IframeParagraphPage";
import IframeHistory from "../IframeHistory";

export function defineEngine(adapter, container: Container) {
	let config = container.get<SystemConfig>(SERVICE_IDENTIFIER.SystemConfig);

	container
		.bind<any>(SERVICE_IDENTIFIER.MadnesAdapter)
		.toConstantValue(adapter);
	madnes.registerAdapter(container.get<any>(SERVICE_IDENTIFIER.MadnesAdapter));

	container
		.bind<MadnesCommander>(SERVICE_IDENTIFIER.Commander)
		.to(MadnesCommander)
		.inSingletonScope();

	container
		.bind<IEngine>(SERVICE_IDENTIFIER.Engine)
		.to(MadnesEngine)
		.inSingletonScope();

	container
		.bind<AbstractIframePage>(SERVICE_IDENTIFIER.InfoPages)
		.to(IframeInfopages)
		.inSingletonScope();
	container
		.bind<AbstractIframePage>(SERVICE_IDENTIFIER.ParagraphPage)
		.to(IframeParagraphPage)
		.inSingletonScope();
	container
		.bind<AbstractIframePage>(SERVICE_IDENTIFIER.History)
		.to(IframeHistory)
		.inSingletonScope();
	container
		.bind<IAudio>(SERVICE_IDENTIFIER.EngineAudio)
		.to(MadnesAudio)
		.inSingletonScope();
	container
		.bind<ILoader>(SERVICE_IDENTIFIER.EngineLoader)
		.to(MadnesLoader)
		.inSingletonScope();
	container
		.bind<EngineDebug>(SERVICE_IDENTIFIER.EngineDebug)
		.to(MadnesDebug)
		.inSingletonScope();

	container
		.bind<IApp>(SERVICE_IDENTIFIER.EngineApp)
		.to(MadnesApp)
		.inSingletonScope();
	container
		.bind<IInitApp>(SERVICE_IDENTIFIER.EngineAppInit)
		.to(InitMadnesApp)
		.inSingletonScope();

	// let engine = container.get<EngineApp>(SI.EngineApp);
	// console.log(engine);
}

export function defineGame(container: Container) {
	defineSlotGame(container, {
		GameCore: GameMadnesCore,
	});
}
